import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import MutualFundDetailBody from '../components/MutualFundDetailBody'
import { useEffect, useMemo, useState } from 'react'
import { goBack, lightImpactVibrate } from '../utils/appBridge'
import BackButton from '../components/ui-components/BackButton'
import MFHeaderSkeleton from '../components/skeletons/MFHeaderSkeleton'
import { useSetAppBarTheme } from '../hooks/useSetAppBarTheme'
import { getTopPadding } from '../utils/sessionStorage'

export default function MutualFundDetailPage() {
  const [isin, setISIN] = useState('')
  const { isin: paramsISIN } = useParams<{ isin: string }>()

  useSetAppBarTheme({ appBarTheme: 'dark' })

  const navigate = useNavigate()

  useEffect(() => {
    setISIN('')
    setTimeout(() => {
      setISIN(paramsISIN ?? '')
    }, 0)
  }, [paramsISIN])

  const [searchParams] = useSearchParams()

  const from = useMemo(() => {
    return searchParams?.get('from') ?? ''
  }, [searchParams])

  const handleBack = () => {
    lightImpactVibrate()
    if (from) goBack()
    else navigate(-1)
  }

  if (isin) return <MutualFundDetailBody />

  return (
    <div className='flex flex-col gap-3 pl-[19px] pr-5 w-full h-screen'>
      <div style={{ paddingTop: `${getTopPadding()}px` }} className='flex pb-4'>
        <BackButton size={24} onClick={handleBack} />
      </div>
      <div>
        {/* <MFHeaderSkeleton /> */}
      </div>
    </div>
  )
}
